<template>
  <div class="cyzs-image" :style='wrapStyle' :class='wrapClass'>
    <img :src="displayImage.path">
  </div>
</template>

<script type="text/babel">
  import {formatImageByQiniu} from 'UTILS/_url'

  export default {
    props:{
      image:{
        type: [Object, String],
        default(){
          return {};
        },
        required: true
      },
      width:{
        type: [Number, String],
        default: 0
      },
      height:{
        type: Number,
        default: 0
      },
      compress:{
        type:Number,
        default:1
      },
      ignoreHeight:{
        type: Boolean,
        default: false
      },
      ignoreWidth:{
        type: Boolean,
        default: false
      },
      formatJpg:{
        type:Boolean,
        default: false
      }
    },
    computed:{
      displayImage(){
        let img = {}
        if (typeof this.image == 'object') {
          img = Object.assign({},this.image);
          if(this.image.path){
            img.path = formatImageByQiniu(this.image.path,this.width,this.height,this.compress,this.ignoreHeight,this.ignoreWidth,this.formatJpg)
          }else if(this.image.image){
            img.path = formatImageByQiniu(this.image.image,this.width,this.height,this.compress,this.ignoreHeight,this.ignoreWidth,this.formatJpg)
          } 
          return img;
        } else if (typeof this.image == 'string') {
          img.path = formatImageByQiniu(this.image,this.width,this.height,this.compress,this.ignoreHeight,this.ignoreWidth,this.formatJpg)
          return img
        }
      },
      wrapStyle(){
        let style;
        if(this.width && this.height){
          style = {
            width:`${this.width}px`,
            height:`${this.height}px`
          }
        }else if(this.width){
          style = {
            width:`${this.width}px`,
            height:`${this.width*this.image.height/this.image.width}px`
          }
        }else if(this.height){
          style = {
            width:`${this.height*this.image.width/this.image.height}px`,
            height:`${this.height}px`
          }
        }else{
          style = {
            width:'750px',
            height:`${750*this.image.height/this.image.width}px`
          }
        }
        style.backgroundSize = `${Math.min(Math.min(parseInt(style.width),parseInt(style.height)) / 300,1) * 160}px`;
        return style;
      },
      wrapClass(){
        if(this.width && this.height){
          if(this.image.width/this.image.height > this.width/this.height){
            return 'cy-img-width-auto-center';
          }else{
            return 'cy-img-height-auto-center';
          }
        }
        return '';
      }
    }
  }
</script>


<style rel="stylesheet/less" lang="less" scoped>
  .cyzs-image{
    position: relative;
    overflow: hidden;
    img{
      display: block;
      width: 100%;
      height: auto;
    }
  }
</style>
